import { combineSlices } from "@reduxjs/toolkit";
import Cookies from "cookies-js";
import { persistReducer } from "redux-persist";
import { CookieStorage } from "redux-persist-cookie-storage";
import localStorage from "redux-persist/lib/storage";
import sessionStorage from "redux-persist/lib/storage/session";

import { brasilApi, ipifyApi, nextCargoApi } from "./apis";
import { acceptTermsSlice, authSlice } from "./slices";

const persistConfig = {
  key: "@root",
  storage: localStorage,
  version: 1,
  blacklist: [nextCargoApi.reducerPath, brasilApi.reducerPath, ipifyApi.reducerPath, authSlice.name, acceptTermsSlice.name]
};

const authPersistConfig = {
  key: "@auth",
  version: 1,
  storage: sessionStorage
};

const acceptTermsConfig = {
  key: "userTerm",
  version: 1,
  storage: new CookieStorage(Cookies)
};

export const rootReducer = combineSlices(nextCargoApi, brasilApi, ipifyApi, {
  [authSlice.name]: persistReducer(authPersistConfig, authSlice.reducer),
  [acceptTermsSlice.name]: persistReducer(acceptTermsConfig, acceptTermsSlice.reducer)
});

export const persistedReducer = persistReducer(persistConfig, rootReducer);
